import { makeApiRequest } from '@/src/lib/api-request'
import { useMutation, useQueryClient } from '@tanstack/react-query'
interface ChannelData {
  channel_id: string
  comment: string
}

export const useReportChannel = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationKey: ['user', 'update'],
    mutationFn: async (data: ChannelData) => {
      await makeApiRequest({
        url: '/channel/report_user',
        method: 'POST',
        data,
        isAuthenticated: true,
        fallbackError: 'Failed to report channel',
        isV3Api: true,
      })
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['reported-users'] })
      queryClient.invalidateQueries({ queryKey: ['user-activities'] })
    },
  })
}
